






























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import ProductCard from 'components/catalog/Product/ProductCard.vue';
import { useImage } from '@wemade-vsf/composables';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';

import SkeletonLoader from 'components/theme/SkeletonLoader.vue';

export default defineComponent({
  components: {
    ProductCard,
    SkeletonLoader,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:add-to-cart'],
  setup() {
    const { imageSizes: { productCard: imageSize } } = useImage();

    return {
      imageSize
    };
  },
});
